import React, { useEffect, useContext, useState } from "react";
import { Helmet } from "react-helmet";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";
import "./mobileDatatableStyles.css";
import {
  Box,
  Chip,
  Collapse,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import LongTextComponent from "../Leads Page/LongTextComponent";

function MobileRemarkDatatable({ data }) {
  
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [expandedRows, setExpandedRows] = useState([]);

  const handleRowClick = (index) => {
    const newExpandedRows = expandedRows.includes(index)
      ? expandedRows.filter((i) => i !== index)
      : [...expandedRows, index];
    setExpandedRows(newExpandedRows);
  };

  const getColorForTag = (tag) => {
    switch (tag.toLowerCase()) {
      case "hot":
        return "error"; // React blue
      case "warm":
        return "warning"; // JavaScript yellow
      case "cold":
        return "info"; // UI dark blue
      default:
        return "default"; // Default gray
    }
  };

  const rowExpansionTemplate = (data) => (
    <Grid container spacing={1} p={1}>
      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography variant="body2">Category:</Typography>
        <Chip
          label={data.category}
          color={getColorForTag(data.category)}
          size="small"
          sx={{ textTransform: "capitalize" }}
        />
      </Grid>

      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography variant="body2">Sub-Category:</Typography>
        <Typography variant="body2">{data.sub_category || "-"}</Typography>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography variant="body2">Remarks:</Typography>
        <Typography variant="body2" sx={{ textAlign: "end" }}>
          <LongTextComponent text={(data.remark === undefined || data.remark === null) ? "-" : data.remark} maxLength={50} />
        </Typography>
      </Grid>
    </Grid>
  );

  const paginatedData = data.slice(
    page * rowsPerPage,
    (page + 1) * rowsPerPage
  );

  return (
    <Paper>
      <TableContainer
        sx={{
          boxShadow: 2,
          borderRadius: "8px",
          margin: "8px 0",
        }}
      >
        <Table
          sx={{
            minWidth: 250,
            height: "100%",
            tableLayout: "fixed", // Ensures equal column width distribution
          }}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow sx={{ backgroundColor: "#EEF0F4" }}>
              <TableCell
                align="left"
                sx={{
                  padding: 0,
                  fontWeight: "bold",
                  width: 10,
                }}
              ></TableCell>
              <TableCell
                align="left"
                sx={{
                  padding: 1,
                  width: 30,
                  fontWeight: "bold",
                }}
              >
                SNo
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  padding: 1,
                  fontWeight: "bold",
                }}
              >
                Created Date
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  padding: 1,
                  fontWeight: "bold",
                }}
              >
                Follow-up Date
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  padding: 1,
                  fontWeight: "bold",
                }}
              >
                Closure Month
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No Data Available Yet.
                </TableCell>
              </TableRow>
            ) : (
              paginatedData.map((row, index) => (
                <React.Fragment key={row.SNo}>
                  <TableRow sx={{ cursor: "pointer" }}>
                    {/* Expand Action */}
                    <TableCell align="left" sx={{ padding: 0 }}>
                      <button onClick={() => handleRowClick(index)}>
                        {expandedRows.includes(index) ? (
                          <ArrowDropDownIcon />
                        ) : (
                          <ArrowRightIcon />
                        )}
                      </button>
                    </TableCell>

                    {/* Other Columns */}
                    <TableCell align="center">
                      {page * rowsPerPage + index + 1}
                    </TableCell>
                    <TableCell align="center" sx={{ wordBreak: "break-word" }}>
                      {row.createdAt}
                    </TableCell>
                    <TableCell align="center" sx={{ textDecoration: "none" }}>
                      {row.follow_up_date}
                    </TableCell>
                    <TableCell align="center" sx={{ textDecoration: "none" }}>
                      {row.closure_month}
                    </TableCell>
                  </TableRow>

                  {/* Collapse Row */}
                  {expandedRows.includes(index) && (
                    <TableRow>
                      <TableCell colSpan={5} sx={{ padding: 0 }}>
                        <Collapse in={expandedRows.includes(index)}>
                          <Box
                            sx={{
                              padding: 2,
                              overflowX: "auto", // Add horizontal scrolling if content exceeds container width
                            }}
                          >
                            {rowExpansionTemplate(row)}
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  )}
                </React.Fragment>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={data.length} // Total rows
        page={page}
        onPageChange={(event, newPage) => setPage(newPage)}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[10, 20, 25]} // Hide rows per page selection
      />
    </Paper>
  );
}

export default MobileRemarkDatatable;
